import React, { useState } from "react";
import data from "../data/about-data.js";

const About = () => {
  const [activeItemId, setActiveItemId] = useState(null);

  return (
    <div className="page-container about-page">
      <h1 className="main-heading">About Us</h1>
      <p className="paragraph">
        Indelect Technologies Pvt.Ltd. established in the year 1995 by the
        Technocrats having over 18 years of combined expertise in technology and
        mentoring experience in advanced areas of Biomedical Engineering,
        Medical Imaging Technology & Power Electronics. Indelect, over these
        years has acclaimed a high reputation in the international markets apart
        from serving the domestic Indian market. With a sustainable and
        consistently growing progress, Indelect Technologies Pvt. Ltd. has
        evolved into a dominant player in the distribution of Biomedical,
        Medical Imaging & Power Electronic equipments. The organization has
        expanded vastly in its length and breadth and has its foot firmly
        grounded to diverse activities.
      </p>
      <h2 className="sub-heading">Indelect's Journey</h2>
      <div className="timeline-container">
        <ul
          className={`timeline-list timeline-list-nodots${
            activeItemId !== null ? " timeline-list-nodots--active" : ""
          }`}
        >
          {data.map((item) => (
            <li
              key={item.id}
              className={`timeline-item-nodot${
                activeItemId === item.id
                  ? " timeline-item-nodot--active"
                  : activeItemId !== null
                    ? " timeline-item-nodot--inactive"
                    : ""
              }`}
              onMouseEnter={() => setActiveItemId(item.id)}
              onMouseLeave={() => setActiveItemId(null)}
              onFocus={() => setActiveItemId(item.id)}
              onBlur={() => setActiveItemId(null)}
              tabIndex={0}
            >
              <span className="timeline-year-nodot">{item.year}</span>
              <span className="timeline-desc-nodot">{item.description}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default About;
